/* ============================================================================
   SERAFINA — put "Guida alle taglie" on the size row.

   The ScaleChart app block renders its trigger wherever it sits in the product
   layout (currently last, under the payment icons). The button is far from the
   size buttons it explains, so it reads as an afterthought.

   This moves the app's OWN button next to the size label — same element, same
   click handler, so the app keeps full ownership of the chart. We only change
   where it lives in the DOM and let serafina-sizeguide.css style it as part of
   the label row.

   Written defensively: the app injects asynchronously and re-renders on variant
   change, so we observe rather than assume, and never move it twice.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__sfSizeGuideMoved) return;
  window.__sfSizeGuideMoved = true;

  var MOVED = 'sf-sizeguide--moved';
  var SIZE_RX = /^(taglia|taglie|size|misura|talla|größe|pointure)$/i;

  function labelIsSize(label) {
    if (!label) return false;
    /* the label holds the option name plus, for colours, a "— value" span.
       Compare only the leading text so "TAGLIA" matches and "COLORE — Nero" does not. */
    var t = '';
    for (var i = 0; i < label.childNodes.length; i++) {
      var n = label.childNodes[i];
      if (n.nodeType === 3) t += n.textContent;
      else if (n.nodeType === 1 && !n.classList.contains('variant__label-info')) t += n.textContent;
    }
    return SIZE_RX.test(t.replace(/[\s:]+/g, ' ').trim());
  }

  function findSizeLabel() {
    var labels = document.querySelectorAll('.variant__label');
    for (var i = 0; i < labels.length; i++) {
      if (labelIsSize(labels[i])) return labels[i];
    }
    /* fall back: a wrapper whose handle says size (theme sets data-handle on the fieldset) */
    var fs = document.querySelector('.variant-input-wrap[data-handle="taglia"], .variant-input-wrap[data-handle="size"]');
    if (fs) {
      var w = fs.closest('.variant-wrapper');
      if (w) return w.querySelector('.variant__label');
    }
    return null;
  }

  function findTrigger() {
    /* the app's button; id is generated per block so match on the class */
    return document.querySelector('.scalechart-trigger-btn');
  }

  function place() {
    var btn = findTrigger();
    if (!btn) return false;

    var host = btn.closest('.scalechart-wrapper') || btn;
    if (host.classList.contains(MOVED) || host.parentElement && host.parentElement.classList.contains('sf-sizeguide__slot')) {
      return true;                                   /* already where we want it */
    }

    var label = findSizeLabel();
    if (!label) return false;                        /* no size option on this product */

    var row = label.parentElement.querySelector('.sf-sizeguide__slot');
    if (!row) {
      row = document.createElement('span');
      row.className = 'sf-sizeguide__slot';
      /* sit immediately after the label so it shares the label's baseline */
      label.insertAdjacentElement('afterend', row);
      label.classList.add('sf-sizeguide__label');
    }
    row.appendChild(host);
    host.classList.add(MOVED);
    document.documentElement.classList.add('sf-sizeguide-ready');
    return true;
  }

  function boot() {
    if (place()) return;
    /* The app block loads async and re-renders when the variant changes; watch for it
       instead of polling forever. Give up quietly after 20s so we never leak an observer. */
    var obs = new MutationObserver(function () { place(); });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
    /* a couple of cheap retries cover the case where the button appears before the observer */
    var tries = 0;
    var iv = setInterval(function () {
      if (place() || ++tries > 20) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
